import firebase from 'firebase/app'
import 'firebase/firestore'
// import 'firebase/messaging'
import './firebaseAppInitializer'

firebase.firestore().settings({
  cacheSizeBytes: 1000000000, // 1GB
  ignoreUndefinedProperties: true,
  merge: true,
  // ...(location.hostname === "localhost" ? { host: "localhost:8080", ssl: false } : {})
})
if (process.env.isBrowser) {
  firebase
    .firestore()
    .enablePersistence({ synchronizeTabs: true })
    .catch(function (err) {
      console.error(err)
      window.alert(err)
    })
}
const firestore = firebase.firestore()
export default firestore

const { Timestamp, GeoPoint, FieldValue } = firebase.firestore
export { firebase, Timestamp, GeoPoint, FieldValue }
